import React from "react";
import GridContainer from "../../../@jumbo/components/GridContainer";
import PageContainer from "../../../@jumbo/components/PageComponents/layouts/PageContainer";
import IntlMessages from "../../../@jumbo/utils/IntlMessages";

import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";

import MarathonSocresMangementContainer from "@jumbo/Dashboards/Tests/MarathonScores";

const breadcrumbs = [
  { label: <IntlMessages id={"sidebar.main"} />, link: "/" },
  {
    label: <IntlMessages id={"pages.marathonScoreManagement"} />,
    isActive: true,
  },
];

const MarathonScoreManagement = () => {
  return (
    <PageContainer
      heading={<IntlMessages id="pages.marathonScoreManagement" />}
      breadcrumbs={breadcrumbs}
    >
      <GridContainer>
        <Grid item xs={12}>
          <div style={{ marginBottom: '10px' }}>
            <IntlMessages id="pages.marathonScoreManagement.description" />
          </div>
          <Divider />
          <div style={{ marginTop: 24 }}>
            <MarathonSocresMangementContainer />
          </div>
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default MarathonScoreManagement;
